import React, { Component } from 'react';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import Subheader from 'material-ui/Subheader';
import InspectionLog from './InspectionLog';
import './damageReport.css';
import './reportDetails.css';

class ReportDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  render() {
    const { car = [], isIn30Mins } = this.props;
    const { open } = this.state;
    return (
      <Card
        style={{ marginTop: '1em' }}
        expandable
        initiallyExpanded
        onExpandChange={newState => this.setState({ open: newState })}>
        <CardHeader
          title={
            <Subheader
              style={{
                margin: '1.5rem',
                textAlign: 'center',
                padding: '0',
              }}>
              Damage Report
            </Subheader>
          }
          actAsExpander
          showExpandableButton
        />
        <div className="report-description">
          <p>
            Before starting your shift, take 2 minutes to inspect the vehicle for damage or issues. Note the previously
            identified issues in the inspection log. If you find any unlisted damages, gas shortages, late drivers, or
            encounter issues during your shift, it is your responsibility to fill and submit a report.
          </p>
        </div>
        <CardText expandable style={{ padding: 0 }}>
          <InspectionLog open={open} car={car} isIn30Mins={isIn30Mins} />
        </CardText>
      </Card>
    );
  }
}

export default ReportDetails;



// WEBPACK FOOTER //
// ./src/components/Dashboard/ReportDetails.js